export default __webpack_public_path__ + "static/media/marker.9315c42c.svg";